export default __webpack_public_path__ + "static/media/gauge-dashboard.56db7612.svg";